///<reference path="../../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {Component, OnInit} from '@angular/core';
import 'rxjs/add/operator/filter';
import {EnumModel} from '../../models/enum.model';
import {CalcRequestModel} from '../../models/calc-request.model';
import {CalcApiService} from '../../services/calc-api.service';
import {CalcResponseModel} from '../../models/calc-response.model';
import {StorageHelperService} from '../../services/storage-helper.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {environment} from '../../../environments/environment.dev';
import {isUndefined} from 'util';
import {FileURL} from '../../models/FileURL.model';
import {DatumiHelper} from '../../helpers/datum.helper';
import { UserResponseModel } from '../../models/user-response.model';
import { KolektivClients, Kolektivmodel } from '../../models/kolektiv-clients.model';


@Component({
  selector: 'app-this',
  templateUrl: './TarrifCalc.component.html',
  styleUrls: ['./TarrifCalc.component.less']
})
export class TarrifCalcKolektivComponent implements OnInit {

  Resultsmodal = false;
  currentYear: number;
  Meseci: EnumModel[] = [];

  // Age combo
  showAgeDrop = false;
  disableAgeCombo = false;
  insuranceAge: EnumModel = new EnumModel(null, '');
  ageSource: EnumModel[] = [];
  ageErrorMessage = '';

  disableDurationCombo = false;


      // duration combo
      showDurationDrop = false;  
      insuranceDuration: EnumModel = new EnumModel(null, '');
      durationSource: EnumModel[] = [];
      durationErrorMessage = '';



  clients: KolektivClients[] = [];
  clientsOut: KolektivClients[] = [];


  //option
  PrToVs = true;
  VsToPr = false;

  calcRequestModel: CalcRequestModel = new CalcRequestModel();
  fileURL: FileURL = new FileURL();
  loader = false;
  calcRequestModelForm: CalcRequestModel = new CalcRequestModel();
  calcResponseModel: CalcResponseModel = new CalcResponseModel();
  klijent: KolektivClients = new KolektivClients();
  kolektivmodel:Kolektivmodel = new Kolektivmodel();
  userForm: FormGroup;

  type: string;



    // Payment combo
    showPaymenteDrop = false;
    disablePaymentCombo = false;
    insurancePayment: EnumModel = new EnumModel(null, '');
    PaymentSource: EnumModel[] = [];
    PaymentErrorMessage = '';




  private currentUser: string = 'currentUser';
  private user: UserResponseModel = new UserResponseModel();

  constructor(private webShopApiService: CalcApiService, private router: Router, private fb: FormBuilder) {

    this.userForm = fb.group({
      'OValue': [null],
      'RDZValue': [null],
      'brojOsiguranika': [null],

    });   



    this.calcRequestModel = StorageHelperService.GetData('CalcRequestModel');
    if (!this.calcRequestModel) {
    //  this.router.navigate(['home']);
    }

  }

  ngOnInit() {


    this.retrieveCurrentUser();

    if(this.calcRequestModel == null){
      this.router.navigate(['TarrifChoos'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });
    }

    this.currentYear = DatumiHelper.racunajgodinu(false);



    sessionStorage.clear();
    this.initAge(); 
    this.initPopusti();
    
    this.initPayment();  
    
   
  }

  public initPayment(){



    this.PaymentSource.push(new EnumModel(0, 'МКД'));
    this.PaymentSource.push(new EnumModel(1, 'ЕУР'));

    this.insurancePayment = this.PaymentSource[0];

  }

  public initPopusti(){


    this.durationSource.push(new EnumModel(100, '100%'));
    this.durationSource.push(new EnumModel(75, '75%'));
    this.durationSource.push(new EnumModel(50, '50%'));
    this.durationSource.push(new EnumModel(25, '25%'));
    

  this.insuranceDuration = this.durationSource[0];
  }

  
  selectInsurancePayment(duration: EnumModel) {
    this.PaymentErrorMessage = '';
    this.insurancePayment = duration;
    this.showPaymenteDrop = false;
  }

  onClickOutsidePaymentCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showPaymenteDrop = false;
    }
  }

  PaymentComboEvent() {
    if (!this.disablePaymentCombo) {
      this.showPaymenteDrop = !this.showPaymenteDrop;
    }
  }



  
  selectInsuranceDuration(duration: EnumModel) {
    this.durationErrorMessage = '';
    this.insuranceDuration = duration;
    this.showDurationDrop = false;
  }

  onClickOutsideDurationCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showDurationDrop = false;
    }
  }

  durationComboEvent() {
    if (!this.disableDurationCombo) {
      this.showDurationDrop = !this.showDurationDrop;
    }
  }



  togglePrVS() {
    // this.errorMessage = '';
    this.PrToVs = !this.PrToVs;
    this.VsToPr = false;
    this.calcRequestModel.VrstaIzracuna = 0;
  }

  toggleVsPr() {

    this.VsToPr = !this.VsToPr;
    this.PrToVs = false;
    this.calcRequestModel.VrstaIzracuna = 1;
  }


  public retrieveCurrentUser() {

    const storedUser: string = localStorage.getItem(this.currentUser);
    if (!storedUser) { throw new Error('no user found'); }


    try {
      this.user = JSON.parse(storedUser);
    } catch (err) {
      console.error(err);
    }
    return this.user;
  }

  
  // DodajOsiguranika()
  // {

  //   this.klijent= new KolektivClients();
  //   this.klijent.id = Math.random();
  //   this.klijent.age = this.insuranceAge.id;
  //   this.klijent.premiumEUR = 0;
  //   this.klijent.premiumMKD = 0;
  //   this.klijent.os = this.userForm.controls['OValue'].value;
  //   this.clients.push( this.klijent);

  // }

  ObrisiOsiguranika(klijent: KolektivClients)
  {
    this.clients = this.clients.filter(item => item !== klijent);

  }
 
  initAge() {
    const AgeFrom =  this.currentYear - 69;
    const AgeTo = this.currentYear - 14;
    for (let i = AgeFrom; i <= AgeTo; i++) {
      this.ageSource.push(new EnumModel(i, String(i)));
    }

    this.insuranceAge = new EnumModel(AgeFrom, String(AgeFrom));
    //this.insuranceDuration = new EnumModel(10, String(10));
  }

  
  selectInsuranceAge(duration: EnumModel) {
    this.ageErrorMessage = '';
    this.insuranceAge = duration;
    this.showAgeDrop = false;
  }



  onClickOutsideAgeCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showAgeDrop = false;
    }
  }



  AgeComboEvent() {

    if (!this.disableDurationCombo) {
      this.showAgeDrop = !this.showAgeDrop;
    }

  }







  submitCalc() {
    this.loader = true;   
   

    
    this.kolektivmodel.brojOsiguranika = this.userForm.controls['brojOsiguranika'].value; 
    this.kolektivmodel.starost = this.insuranceAge.id;
    this.kolektivmodel.iznos = this.userForm.controls['OValue'].value; 
    this.kolektivmodel.vrstaIzracuna = this.PrToVs === true ? 0:1;
    this.kolektivmodel.sema = this.insuranceDuration.id;
    this.kolektivmodel.valuta = this.insurancePayment.id ==0 ? 'MKD':'EUR';

    this.kolektivmodel.lClients = this.clients;
 
    this.webShopApiService.calculateKolektiv(this.kolektivmodel)
      .subscribe(
        (response) => {
      
          var kolektivmodelResponse = response;

          this.kolektivmodel.napomena=kolektivmodelResponse.napomena
          this.clientsOut = kolektivmodelResponse.lClients;
          this.loader = false;
        },
        (error) => {
          console.log(error);
          this.loader = false;
        }
      );
    window.scroll(0, 0);
    this.Resultsmodal = true;
   }



  downloadInfoPdf() {
     this.loader = true;
    this.webShopApiService.downloadpdf(this.calcResponseModel)
      .subscribe(
        (response) => {
          this.fileURL = response;
         // const fileUrl = response;
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.setAttribute('target', '_blank');
          a.href = this.fileURL.fileURL;
          a.download = '';
          a.click();
          a.remove();
             this.loader = false;
        },
        (error) => {
            this.loader = false;
        }
      );
  }

  

}



// WEBPACK FOOTER //
// ./src/app/pages/TarrifCalcKolektiv/TarrifCalc.component.ts